import { render, staticRenderFns } from "./addLinkAudio.vue?vue&type=template&id=0d2bcea6"
import script from "./addLinkAudio.vue?vue&type=script&lang=js"
export * from "./addLinkAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports